import React, { useCallback, useEffect, useState } from 'react';
import { GoChevronLeft } from 'react-icons/go';
import * as S from './styles';
import { Content } from './Content';
import { ContentIfood } from './ContentIfood';

interface PanelContainerProps {
  selectedOrderId: number | string | null;
  setSelectedOrderId: React.Dispatch<React.SetStateAction<number | string | null>>;
}

const MainContainer: React.FC<PanelContainerProps> = (props) => {
  const { selectedOrderId, setSelectedOrderId } = props;

  const [isLoading, setIsLoading] = useState(false);

  const handleRemoveSelectedOrderId = (): void => {
    setSelectedOrderId(null);
  };

  useEffect(() => {
    if(selectedOrderId) {
      setIsLoading(true);
    }
  }, [selectedOrderId]);

  return (
    <S.Container selectedOrderId={selectedOrderId}>
      <div className="button__close" onClick={handleRemoveSelectedOrderId}>
        <GoChevronLeft size={20} />
      </div>

      {/* eslint-disable-next-line no-nested-ternary */}
      {selectedOrderId ? (
        typeof selectedOrderId === 'string' ? (
          <ContentIfood
            selectedOrderId={selectedOrderId}
            setIsLoadingMain={setIsLoading}
          />
        ) : (
          <Content 
            selectedOrderId={selectedOrderId}
            setIsLoadingMain={setIsLoading}
          />
        )
      ) : (
        <div
          style={{
            display: 'flex',
            flex: '1',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Nenhum pedido escolhido
        </div>
      )}
    </S.Container>
  );
};

export default MainContainer;
